<div class="flex flex-col h-full">
    <div class="flex items-center" id="page-header">
        <a mat-icon-button routerLink="/tenant-list">
            <mat-icon>arrow_back_ios_new</mat-icon>
        </a>
        <h1>{{ tenantName() }}</h1>
    </div>

    <div id="scroll-content-container" class="flex-auto basis-0">
        <mat-nav-list style="padding: 0" class="flex-auto">
            @for (location of locations(); track location.id) {
                <mat-list-item class="relative">
                    <a
                        matListItemTitle
                        [routerLink]="location.locationRouterLink"
                        class="no-underline after:absolute after:inset-0 after:content-['']"
                    >
                        {{ location.name }}
                    </a>
                    <a
                        matListItemMeta
                        mat-icon-button
                        class="relative z-10"
                        [routerLink]="location.locationSettingsRouterLink"
                        aria-label="Locatie instellingen"
                    >
                        <mat-icon>settings</mat-icon>
                    </a>
                </mat-list-item>
                <mat-divider />
            }
        </mat-nav-list>
    </div>
</div>
